var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.6 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.3,9.4L2.3,4.4v10h6.6s0,.6.2,1,.6,1,.6,1H2.3c-.6,0-1-.2-1.4-.6s-.6-.9-.6-1.4V2.4c0-.6.2-1,.6-1.4.4-.4.9-.6,1.4-.6h16c.6,0,1,.2,1.4.6.4.4.6.9.6,1.4v4.9s-.6-.2-1.1-.3-.9,0-.9,0v-2.5s-8,5-8,5ZM10.3,7.4l8-5H2.3l8,5ZM2.3,4.4v11-6h0V2.4v2ZM17.9,16.7c.8,0,1.6-.3,2.2-.9s.9-1.3.9-2.2-.3-1.6-.9-2.2-1.3-.9-2.2-.9-1.6.3-2.2.9-.9,1.3-.9,2.2.3,1.6.9,2.2c.6.6,1.3.9,2.2.9ZM17.9,15.5c-.5,0-.9-.2-1.3-.5s-.5-.8-.5-1.3.2-.9.5-1.3.8-.5,1.3-.5.9.2,1.3.5.5.8.5,1.3-.2.9-.5,1.3-.8.5-1.3.5ZM17.9,18.8c-1.6,0-3.1-.5-4.5-1.4s-2.3-2.2-2.9-3.7c.6-1.5,1.6-2.8,2.9-3.7s2.9-1.4,4.5-1.4,3.1.5,4.5,1.4,2.3,2.2,2.9,3.7c-.6,1.5-1.6,2.8-2.9,3.7-1.4.9-2.9,1.4-4.5,1.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMsg);
export default __webpack_public_path__ + "static/media/show-msg.bbeeab074f26d6fd9cb59b45cd701d37.svg";
export { ForwardRef as ReactComponent };